export const CountryCodeData = [
  {
    val: 0,
    Code: "AE",
    Country: "United Arab Emirates",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 1,
    Code: "AR",
    Country: "Argentina",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 2,
    Code: "AT",
    Country: "Austria",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 3,
    Code: "AU",
    Country: "Australia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 4,
    Code: "BE",
    Country: "Belgium",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 5,
    Code: "BG",
    Country: "Bulgaria",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 6,
    Code: "BH",
    Country: "Bahrain",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 7,
    Code: "BN",
    Country: "Brunei",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 8,
    Code: "BO",
    Country: "Bolivia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 9,
    Code: "BR",
    Country: "Brazil",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 10,
    Code: "BY",
    Country: "Belarus",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 11,
    Code: "CA",
    Country: "Canada",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  },
  {
    val: 12,
    Code: "CH",
    Country: "Switzerland",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  },
  {
    val: 13,
    Code: "CL",
    Country: "Chile",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 14,
    Code: "CN",
    Country: "China",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 15,
    Code: "CO",
    Country: "Colombia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 16,
    Code: "CR",
    Country: "Costa",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 17,
    Code: "CY",
    Country: "Cyprus",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 18,
    Code: "CZ",
    Country: "Czech Republic",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 19,
    Code: "DE",
    Country: "Germany",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 20,
    Code: "DK",
    Country: "Denmark",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 21,
    Code: "DO",
    Country: "Dominican Republic",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  },
  {
    val: 22,
    Code: "EC",
    Country: "Ecuador",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 23,
    Code: "EE",
    Country: "Estonia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 24,
    Code: "EG",
    Country: "Egypt",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 25,
    Code: "ES",
    Country: "Spain",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 26,
    Code: "FI",
    Country: "Finland",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 27,
    Code: "FR",
    Country: "France",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 28,
    Code: "GB",
    Country: "United Kingdom\t",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 29,
    Code: "GR",
    Country: "Greece",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 30,
    Code: "GT",
    Country: "Guatemala",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 31,
    Code: "HK",
    Country: "Hong Kong",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 32,
    Code: "HN",
    Country: "Honduras",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 33,
    Code: "HR",
    Country: "Croatia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 34,
    Code: "HU",
    Country: "Hungary",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 35,
    Code: "ID",
    Country: "Indonesia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 36,
    Code: "IE",
    Country: "Ireland",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 37,
    Code: "IL",
    Country: "Israel\t",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 38,
    Code: "IN",
    Country: "India",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 39,
    Code: "IS",
    Country: "Iceland",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 40,
    Code: "IT",
    Country: "Italy",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 41,
    Code: "JO",
    Country: "Jordan",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 42,
    Code: "JP",
    Country: "Japan",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 43,
    Code: "KR",
    Country: "Korea Republic",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 44,
    Code: "KW",
    Country: "Kuwait",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 45,
    Code: "LB",
    Country: "Lebanon",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 46,
    Code: "LI",
    Country: "Liechtenstein",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 47,
    Code: "LT",
    Country: "Lithuania",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 48,
    Code: "LU",
    Country: "Luxembourg",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 49,
    Code: "LV",
    Country: "Latvia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 50,
    Code: "MA",
    Country: "Morocco",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 51,
    Code: "MC",
    Country: "Monaco",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 52,
    Code: "MK",
    Country: "Macedonia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 53,
    Code: "MO",
    Country: "Macao",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 54,
    Code: "MX",
    Country: "Mexico",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 55,
    Code: "MY",
    Country: "Malaysia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 56,
    Code: "NL",
    Country: "Netherlands",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 57,
    Code: "NO",
    Country: "Norway",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 58,
    Code: "NZ",
    Country: "New Zealand",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 59,
    Code: "OM",
    Country: "Oman",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 60,
    Code: "PA",
    Country: "Panama",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 61,
    Code: "PE",
    Country: "Peru",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 62,
    Code: "PH",
    Country: "Philippines",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 63,
    Code: "PK",
    Country: "Pakistan",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 64,
    Code: "PL",
    Country: "Poland",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 65,
    Code: "PR",
    Country: "Puerto Rico",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  },
  {
    val: 66,
    Code: "PT",
    Country: "Portugal",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 67,
    Code: "RO",
    Country: "Romania",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 68,
    Code: "RU",
    Country: "Russia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 69,
    Code: "SA",
    Country: "Saudi Arabia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 70,
    Code: "SE",
    Country: "Sweden",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 71,
    Code: "SG",
    Country: "Singapore",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 72,
    Code: "SI",
    Country: "Slovenia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 73,
    Code: "SK",
    Country: "Slovak Republic",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 74,
    Code: "SV",
    Country: "El Salvador",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 75,
    Code: "TH",
    Country: "Thailand",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 76,
    Code: "TN",
    Country: "Tunisia",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 77,
    Code: "TR",
    Country: "Turkey",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 78,
    Code: "TT",
    Country: "Trinidad & Tobago",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 79,
    Code: "TW",
    Country: "Taiwan",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  },
  {
    val: 80,
    Code: "UA",
    Country: "Ukraine",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 81,
    Code: "US",
    Country: "United States",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  },
  {
    val: 82,
    Code: "UY",
    Country: "Uruguay",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 83,
    Code: "UZ",
    Country: "Uzbekistan",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 84,
    Code: "VE",
    Country: "Venezuela",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 85,
    Code: "VN",
    Country: "Vietnam",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    val: 86,
    Code: "ZA",
    Country: "South Africa",
    channel_ids: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
];
